import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import { AnimatePresence, motion } from 'framer-motion';
import splashScreenAnimation from '@src/assets/lotties/splash-screen.json';
import { useGTM } from '@src/shared/hooks';
import { GTMEvents } from '@src/config/gtm';

interface SplashScreenProps {
  onAnimationComplete?: () => void;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({
  onAnimationComplete,
}) => {
  const { trackEvent } = useGTM();

  useEffect(() => {
    trackEvent(GTMEvents.VIEW_ONBOARDING, {});
  }, [trackEvent]);

  const handleAnimationComplete = () => {
    onAnimationComplete?.();
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className='fixed inset-0 z-[9999] flex items-center justify-center'
        style={{ backgroundColor: '#001833' }}
      >
        <Lottie
          animationData={splashScreenAnimation}
          loop={false}
          autoplay={true}
          onComplete={handleAnimationComplete}
          style={{
            width: '100%',
            height: '100%',
            maxWidth: '320px',
            maxHeight: '320px',
          }}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet',
          }}
        />
      </motion.div>
    </AnimatePresence>
  );
};
